// import configuration from "./index";
import { authFetch } from "../utils/authFetch";

export const CommunicationAPI = {
  // Generated by GitHub Copilot
  // Updated to properly return promise for async/await handling (US1778407)
  attachCommunication: async function (problem, outage, communication) {
    const requestOptions = {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(communication),
    };

    const problemURL = `/api/v1/problem/${problem}/outage/${outage}/communication`;

    return authFetch(problemURL, requestOptions)
      .then((res) => {
        if (res.ok) {
          return res.json();
        }
        throw new Error(`Failed to send communication: ${res.status}`);
      })
      .catch((error) => {
        console.error("Communication send error:", error);
        throw error;
      });
  },
};
